/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 * @author Alexander Golshtein
 * @version 1.24.0
 * @since 1.24.0
 */

export const FIXED_LIST_HEIGHT = 200;
export const VIRTUAL_ITEM_HEIGHT_LARGE = 48;
export const VIRTUAL_ITEM_HEIGHT_SMALL = 32;
